export default "__VITE_ASSET__D725gz2y__"